import { createFileRoute, Outlet } from '@tanstack/react-router'
import PrivateRoute from '@/providers/private-routes'

export const Route = createFileRoute('/canny')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  )
}
